module.exports = __webpack_public_path__ + "static/media/icon-close-modal.3b40f53a.svg";